export default "__VITE_ASSET__DuU21BBO__"